export default __webpack_public_path__ + "static/media/team-6.b40a26d5.jpg";